module.exports = __webpack_public_path__ + "static/media/AWO veneer Coffeee Storage table.38723a40.jpg";